import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ModalConfig {
  header: string;
  width?: string;
  dismissableMask?: boolean;
  closable?: boolean;
  styleClass?: string;
}

@Injectable({
  providedIn: 'root'
})
export class RouteRenderModalService {
  private activeModal = new BehaviorSubject<string | null>(null);
  activeModal$ = this.activeModal.asObservable();
  dialogRef: any = null;

  constructor(private router: Router) {
    // Listen to router events to update active modal state
    this.router.events.subscribe(() => {
      const modalOutlet = this.router.parseUrl(this.router.url).queryParams['modal'];
      this.activeModal.next(modalOutlet || null);
    });
  }

  closeModal() {
    this.router.navigate([{ outlets: { modal: null } }]);
  }

  isModalOpen(): Observable<boolean> {
    return new Observable(subscriber => {
      this.activeModal$.subscribe(modal => {
        subscriber.next(!!modal);
      });
    });
  }

  getActiveModal(): Observable<string | null> {
    return this.activeModal$;
  }

  setDialogRef(dialogRef: any) {
    this.dialogRef = dialogRef;
  }
}
